import React from 'react'
import { useApplePayCartButton } from 'modules/payment'
import { Icon } from 'components/dataDisplay'
import ExpressCheckoutButton from 'compositions/payment/ExpressCheckout/components/ExpressCheckoutButton/ExpressCheckoutButton'


const ApplePayCartButton = ({ className }) => {
  const { isReady, isProcessing, submitApplePay } = useApplePayCartButton()

  return (
    <ExpressCheckoutButton
      className={className}
      disabled={isProcessing}
      loading={!isReady}
      onClick={submitApplePay}
      data-testid="applePayButton"
    >
      <Icon name="other/apple-pay-in-cart" />
    </ExpressCheckoutButton>
  )
}

export default ApplePayCartButton
